<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">
        Création de Mandat(s)<span v-if="program"> : {{program.name}}</span>
        <span v-if="company" class="is-italic"> - Pour la société : {{company.name}}</span>
      </span>
    </sticky>
    <div class="columns is-gapless is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-8 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-border">
          <access-form @submit="submit" :loading="loading" ref="accessForm"
                        :sourceCompany="companyPk"
                        :sourcePromoteur="promoteurPk"
                        :sourceProgram="programPk"></access-form>
          <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-right is-border-top columns">
            <div class="column is-6">
              <a @click="$router.goBack(route)" class="button is-white is-uppercase is-fullwidth">
                <span>Annuler</span>
              </a>
            </div>
            <div class="column is-6">
              <button @click="askSubmit" class="button is-success is-uppercase is-fullwidth has-text-white"
                      :disabled="loading" :class="{'is-loading':loading}">
                <span v-if="!loading">Valider</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4 is-3-widescreen">
        <div class="is-border" v-if="helperTitle || helperText">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 is-size-4">
              <b>Le saviez-vous ?</b>
            </div>
            <div class="column has-text-grey">
              <p><b>{{helperTitle}}</b></p>
              <p class="is-margin-top-small">{{helperText}}</p>
            </div>
            <!-- <div class="column is-border-top">
              <p><a class="has-text-grey has-text-weight-medium" >Lien Guide d'utilisation</a></p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AccessForm from '@/components/access/AccessForm'

  export default {
    name: 'AccessCreate',
    components: {
      AccessForm
    },
    data () {
      return {
        loading: false,
        simulateSubmit: false,
        program: null,
        helperTitle: null,
        helperText: null,
        route: this.$route,
        company: null
      }
    },
    computed: {
      programPk () {
        if (this.$route.query) {
          return this.$route.query.program
        } else if (this.program) {
          return this.program.pk
        }
      },
      companyPk () {
        if (this.$route.query) {
          return this.$route.query.company
        } else if (this.company) {
          return this.company.pk
        }
      },
      promoteurPk () {
        if (this.$route.query) {
          return this.$route.query.promoteur
        } else if (this.promoteur) {
          return this.promoteur.pk
        }
      }
    },
    methods: {
      askSubmit () {
        this.$refs.accessForm.submit()
      },
      submit (access) {
        this.$notify({
          type: 'is-info',
          text: 'Création des mandats en cours...'
        })
        this.simulateSubmit = false
        this.loading = true
        this.$api.accessService.post(access)
          .then(res => {
            this.$router.goBack(this.$route)
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.$notify({
              type: 'is-danger',
              text: 'Erreur lors de l\'ajout du mandat.'
            })
          })
      },
      getProgram () {
        this.$api.programService.getOne(this.programPk).then(r => {
          this.program = r.data
        })
      },
      getCompany () {
        this.$api.companyService.getOne(this.companyPk).then(r => {
          this.company = r.data
        })
      },
      getHelper () {
        if (this.$contentful) {
          this.$contentful.getEntry('46f2Mm3NDyUK6EEeeOIecE').then(entry => {
            this.helperTitle = entry.fields.title
            this.helperText = entry.fields.text
          })
        }
      }
    },
    created () {
      if (this.programPk) this.getProgram()
      if (this.promoteurPk) this.getProgram()
      if (this.companyPk) this.getCompany()
      this.getHelper()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/access/AccessCreate.vue